
class I96ScrollChecker {

    constructor(config = {}) {

        this.debug_scroll = config.debug ?? false;

        this.scroll_data = {

            scroll_callback: config.scroll_callback ?? false,

            pos: {
                last: -1,
                curr: 0,
                diff: 1,
                /** Accumulated movement in scroll direction */
                dir_acc: 0,
                /** Direction of scroll movement */
                dir_change: true
            }
        }

    }

    /**
     * Hooks into the scroll event to check the scroll data on scroll and call the callback function
     *
     * @param callback function to be called on EVERY scroll
     * @private
     */
    _setupScroll( callback ) {
        if (this.debug_scroll) console.log('I96ScrollChecker: _setupScroll()');

        window.addEventListener(
            'scroll',
            this._checkerOnScroll.bind(this)
        );

        this.scroll_data.scroll_callback = callback;

        this._checkerOnScroll()

    }

    _checkerOnScroll() {
        // if (this.debug_scroll) console.log('I96ScrollChecker: _onScroll()');

        this._calculateScrollData();

        if (this.scroll_data.scroll_callback !== false) {
            this.scroll_data.scroll_callback();
        }

        this._showScrollDebug();

    }

    /**
     * Calculate all the values related to the scrolling, like scroll position, direction, ...
     *
     * @private
     */
    _calculateScrollData() {
        this.scroll_data.pos.curr = window.scrollY
        this.scroll_data.pos.diff = this.scroll_data.pos.last - this.scroll_data.pos.curr
        this.scroll_data.pos.dir_change =
            (this.scroll_data.pos.dir_acc < 0 && this.scroll_data.pos.diff > 0)
            || (this.scroll_data.pos.dir_acc > 0 && this.scroll_data.pos.diff < 0)
        if (this.scroll_data.pos.dir_change) {
            this.scroll_data.pos.dir_acc = 0
        }
        this.scroll_data.pos.dir_acc += this.scroll_data.pos.diff
        this.scroll_data.pos.dir_up = this.scroll_data.pos.dir_acc > 0
        this.scroll_data.pos.dir_down = !this.scroll_data.pos.dir_up

        this.scroll_data.pos.last = this.scroll_data.pos.curr
    }


    /**
     * Shows the relevant scroll data in an overlay
     *
     * @private
     */
    _showScrollDebug() {
        if (this.debug_scroll) {
            let debugel = document.getElementById('i96-scroll-debug')
            if (!debugel) {
                var newNode = document.createElement('div');
                newNode.id = 'i96-scroll-debug';
                newNode.style.background = '#c0e3c0';
                newNode.style.position = 'fixed';
                newNode.style.top = '100px';
                newNode.style.left = '1rem';
                newNode.style.fontSize = '0.7rem';
                newNode.style.lineHeight = '1';
                newNode.style.padding = '0.5rem 1rem';
                newNode.style.zIndex = '100';
                document.body.appendChild(newNode);
                debugel = document.getElementById('i96-scroll-debug');
            }
            let str = ''
            // str += '<b style="min-width:64px;display:inline-block;">' + ele + '</b>' + this.scroll_data.pos[ele] + '<br>'
            Object.keys(this.scroll_data.pos).forEach(ele => {
                str += '<b style="min-width:64px;display:inline-block;">' + ele + '</b>' + this.scroll_data.pos[ele] + '<br>'
            })
            debugel.innerHTML = str
        }
    }

}

export default I96ScrollChecker
